export type PaymentMethodType =
	| 'paypal'
	| 'creditcard'
	| 'check'
	| 'ach'
	| 'accountcredit'
	| 'legacy'
	| 'balancetransfer'
	| 'multiple'
	| 'unknown';

const normalizePaymentMethodType = (
	type: string | null | undefined,
): PaymentMethodType | null => {
	if (!type) return null;

	const typeCleaned = type
		.toLowerCase()
		.trim()
		.replaceAll('_', '')
		.replaceAll('-', '');

	if (typeCleaned === 'paypal') return 'paypal';
	if (typeCleaned === 'card') return 'creditcard';
	if (typeCleaned === 'creditcard') return 'creditcard';
	// Stripe only processes cards here, so `stripe` never stands for a bank debit.
	if (typeCleaned === 'stripe') return 'creditcard';
	if (typeCleaned === 'check') return 'check';
	if (typeCleaned === 'ach') return 'ach';
	if (typeCleaned === 'accountcredit') return 'accountcredit';
	if (typeCleaned === 'legacy') return 'legacy';
	if (typeCleaned === 'balancetransfer') return 'balancetransfer';
	if (typeCleaned === 'multiple') return 'multiple';

	return null;
};

export default normalizePaymentMethodType;
